/* global axios */
import ApiClient from './ApiClient';

class InboxConversationTransferAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  resourceUrl(inboxId) {
    return `${this.url}/${inboxId}/conversation_transfers`;
  }

  fetchTransfers(inboxId, { page = 1, perPage, status, createdAtAfter } = {}) {
    const params = { page };
    if (perPage) params.per_page = perPage;
    if (status) params.status = status;
    if (createdAtAfter) params.created_at_after = createdAtAfter;
    return axios.get(this.resourceUrl(inboxId), { params });
  }

  fetchTransfer(inboxId, transferId) {
    return axios.get(`${this.resourceUrl(inboxId)}/${transferId}`);
  }

  preview(inboxId, payload) {
    return axios.post(`${this.resourceUrl(inboxId)}/preview`, payload);
  }

  createTransfer(inboxId, payload) {
    return axios.post(this.resourceUrl(inboxId), payload);
  }

  cancelTransfer(inboxId, transferId) {
    return axios.delete(`${this.resourceUrl(inboxId)}/${transferId}`);
  }

  retryTransfer(inboxId, transferId) {
    return axios.post(`${this.resourceUrl(inboxId)}/${transferId}/retry`);
  }
}

export default new InboxConversationTransferAPI();
